@if (sale) {
  <div class="container single-view" id="edit-sale">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/sales/' + saleId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SALES.BTN_BACK_TO_SALE' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-sale-title" class="section-title">{{ 'SALE_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="saleForm" data-testid="edit-sale-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="edit-sale-details-title" class="border-b pb-3">{{ 'SALE_UPDATE.SALE_DETAILS' | translate }}</h2>
                  </div>
                  <!-- Sale details -->
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 disabled">
                    <label data-testid="edit-sale-field-product" class="block text-sm" for="item">{{ 'SALE_UPDATE.PRODUCT' | translate }}</label>
                    <input data-testid="edit-sale-product-input" type="text" formControlName="item" autocomplete="off">
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 disabled">
                    <label data-testid="edit-sale-field-serialnumber" class="block text-sm mb-2" for="item">{{ 'SALE_UPDATE.SERIAL_NUMBER' | translate }}</label>
                    <div class="flex items-stretch camera-btn-field-wr">
                      <input data-testid="edit-sale-serialnumber-input" type="text" id="search-sn" formControlName="serialNumber" autocomplete="off">
                      <textbox-camera data-testid="edit-sale-serialnumber-textboxcamera" class="shrink-0 self-stretch flex items-center" [disabled]="disabledCamera" (qrCodeScanned)="qrCodeScanned($event)"></textbox-camera>
                    </div>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-sale-field-date" class="block text-sm" for="date">{{ 'SALE_CREATE.SALE_DATE' | translate }}</label>
                    <p-datepicker data-testid="edit-sale-date-input" class="w-100" formControlName="date" dateFormat="dd-mm-yy" [maxDate]="currentDate" placeholder="{{ 'SALE_CREATE.DATE_PLACEHOLDER' | translate }}" showIcon="true" [showTime]="true" appendTo="body" />
                  </div>
                  @if (canViewPrice) {
                    <div [ngClass]="{'disabled':!canModifyPrice}" class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                      <label data-testid="edit-sale-field-price" class="block text-sm" for="price">{{ 'SALE_CREATE.PRICE' | translate }}</label>
                      <input data-testid="edit-sale-price-input" type="text" formControlName="price" autocomplete="off">
                      @if (saleForm.get('price')?.invalid && (saleForm.get('price')?.dirty || saleForm.get('price')?.touched)) {
                        @if (saleForm.get('price')?.errors?.['required']) {
                          <small class="p-error">
                            {{ 'SALE_CREATE.VALIDATE_PRICE' | translate }}
                          </small>
                        }
                        @if (saleForm.get('price')?.errors?.['pattern']) {
                          <small class="p-error">
                            {{ 'SALE_CREATE.FORMAT_PRICE' | translate }}
                          </small>
                        }
                      }
                    </div>
                  }
                  @if (showCustomer) {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                      <label data-testid="edit-sale-field-customer" class="block text-sm" for="customer">{{ 'SALE_CREATE.CUSTOMER' | translate }}</label>
                      <app-custom-dropdown
                        data-testid="customer"
                        [placeholder]="'SALE_CREATE.SELECT_CUSTOMER_PLACEHOLDER' | translate"
                        optionLabel="text"
                        optionValue="id"
                        [isMultiselect]="false"
                        [showSelectionChips]="true"
                        [showClear]="false"
                        [searchMode]="'remote'"
                        [pageSize]="customersRowsPerPageOption"
                        [totalCount]="customersTotalRecords"
                        [totalPages]="getTotalPages(customersTotalRecords, customersRowsPerPageOption)"
                        [options]="customersList"
                        formControlName="customerId"
                        (onLazyLoad)="onLazyLoadCustomers($event)">
                      </app-custom-dropdown>
                    </div>
                  }
                  @if (showIsLegacyField) {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                      <div class="row">
                        <div class="col-12">
                          <span data-testid="edit-sale-field-islegacy" class="label text-sm">{{ 'SALE_CREATE.IS_LEGACY' | translate }}</span>
                          <label data-testid="edit-sale-islegacy-yes-label" class="inline-flex mr-6">
                            <p-radioButton data-testid="edit-sale-islegacy-yes" name="isLegacy" value="true" formControlName="isLegacy" inputId="yes" />
                            <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                          </label>
                          <label data-testid="edit-sale-islegacy-no-label" class="inline-flex mr-2">
                            <p-radioButton data-testid="edit-sale-islegacy-no" name="isLegacy" value="false" formControlName="isLegacy" inputId="no" />
                            <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <div class="row">
                      <div class="col-12">
                        <span data-testid="edit-sale-field-isgift" class="label mb-3 text-sm">{{ 'SALE_CREATE.IS_GIFT' | translate }}</span>
                        <label data-testid="edit-sale-isgift-yes-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="edit-sale-isgift-yes" name="isGift" value="true" formControlName="isGift" inputId="yes" />
                          <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                        </label>
                        <label data-testid="edit-sale-isgift-no-label" class="inline-flex mr-2">
                          <p-radioButton data-testid="edit-sale-isgift-no" name="isGift" value="false" formControlName="isGift" inputId="no" />
                          <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="field-wr flex flex-col col-12 mt-2">
                      <div class="row">
                        <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                          <label class="block text-sm">{{ 'SALE_CREATE.SELLER_TYPE' | translate }}</label>
                          <div class="flex flex-wrap gap-4">
                            @if (canUseMyselfSeller && !(!hasUnregisteredUserFeature && saleForm.get('sellerType')?.value === 'guest' && !saleForm.get('changeSeller')?.value)) {
                              <label data-testid="sellertype-myself-label" class="inline-flex mr-6">
                                <p-radioButton data-testid="sellertype-myself" name="sellerType" value="myself" formControlName="sellerType" inputId="seller-type-myself" (onClick)="onSellerTypeChange($event)" />
                                <span for="seller-type-myself" class="ml-2">{{ 'SALE_CREATE.OPTION_SYSTEM_MYSELF' | translate }}</span>
                              </label>
                            }
                            @if (!(!hasUnregisteredUserFeature && saleForm.get('sellerType')?.value === 'guest' && !saleForm.get('changeSeller')?.value)) {
                              <label data-testid="sellertype-system-label" class="inline-flex mr-6">
                                <p-radioButton data-testid="sellertype-system" name="sellerType" value="system" formControlName="sellerType" inputId="seller-type-system" (onClick)="onSellerTypeChange($event)" />
                                <span for="seller-type-system" class="ml-2">{{ 'SALE_CREATE.OPTION_SYSTEM_SELLER' | translate }}</span>
                              </label>
                            }
                            @if (hasUnregisteredUserFeature) {
                              <label data-testid="sellertype-guest-label" class="inline-flex mr-2">
                                <p-radioButton data-testid="sellertype-guest" name="sellerType" value="guest" formControlName="sellerType" inputId="seller-type-guest" (onClick)="onSellerTypeChange($event)" />
                                <span for="seller-type-guest" class="ml-2">{{ 'SALE_CREATE.OPTION_GUEST_SELLER' | translate }}</span>
                              </label>
                            }
                            @if ((!hasUnregisteredUserFeature && saleForm.get('sellerType')?.value == 'guest') || (!hasUnregisteredUserFeature && saleForm.get('changeSeller')?.value)) {
                              <div class="flex items-center gap-2 whitespace-nowrap">
                                <p-checkbox binary="true" formControlName="changeSeller" inputId="changeSeller" />
                                <label for="changeSeller" class="text-sm cursor-pointer">{{ 'SALE_CREATE.CHANGE_SELLER' | translate }}</label>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      @if (saleForm.get('sellerType')?.value === 'myself') {
                        <div class="row">
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
                            <label data-testid="myself-retailer-label" class="block text-sm" for="myselfRetailerId">
                              {{ 'SALE_CREATE.POINT_OF_SALE' | translate }} <i class="icon-required-field"></i>
                            </label>
                            <app-custom-dropdown data-testid="myself-retailer"
                              [placeholder]="'SALE_CREATE.SELECT_RETAILER' | translate"
                              optionLabel="text"
                              optionValue="id"
                              [isMultiselect]="false"
                              [showSelectionChips]="true"
                              [showClear]="true"
                              [searchMode]="'remote'"
                              [pageSize]="combosData['myselfRetailers'].rowsPerPageOption || 5"
                              [totalCount]="combosData['myselfRetailers'].totalRecords"
                              [totalPages]="getTotalPages(combosData['myselfRetailers'].totalRecords, combosData['myselfRetailers'].rowsPerPageOption || 5)"
                              [options]="combosData['myselfRetailers'].list"
                              formControlName="myselfRetailerId"
                              (onLazyLoad)="onLazyLoadComboData('myselfRetailers', $event)">
                            </app-custom-dropdown>
                            @if (combosData['myselfRetailers'].totalRecords === 0) {
                              <small data-testid="myself-retailer-error" class="p-error">{{ 'SALE_CREATE.USER_HAS_NO_RETAILERS_ASSIGNED' | translate }}</small>
                            } @else {
                              @if (saleForm.get('myselfRetailerId')?.invalid && saleForm.get('myselfRetailerId')?.touched) {
                                <small data-testid="myself-retailer-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                              }
                            }
                          </div>
                          @if(showDistributionChannel){
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" [ngClass]="{ 'disabled': !saleForm.get('myselfRetailerId')?.value?.length }">
                            <label data-testid="myself-distributionchannel-label" class="block text-sm" for="myselfDistributionChannelId">
                              {{ 'SALE_CREATE.DISTRIBUTION_CHANNEL' | translate }} <i class="icon-required-field"></i>
                            </label>
                            <app-custom-dropdown data-testid="myself-distributionChannel"
                              [placeholder]="'SALE_CREATE.SELECT_DISTRIBUTION_CHANNEL' | translate"
                              optionLabel="text"
                              optionValue="id"
                              [isMultiselect]="false"
                              [showSelectionChips]="true"
                              [showClear]="true"
                              [searchMode]="'remote'"
                              [pageSize]="combosData['myselfDistributionChannels'].rowsPerPageOption || 5"
                              [totalCount]="combosData['myselfDistributionChannels'].totalRecords"
                              [totalPages]="getTotalPages(combosData['myselfDistributionChannels'].totalRecords, combosData['myselfDistributionChannels'].rowsPerPageOption || 5)"
                              [options]="combosData['myselfDistributionChannels'].list"
                              formControlName="myselfDistributionChannelId"
                              (onLazyLoad)="onLazyLoadComboData('myselfDistributionChannels', $event)">
                            </app-custom-dropdown>
                            @if (saleForm.get('myselfDistributionChannelId')?.invalid && saleForm.get('myselfDistributionChannelId')?.touched) {
                              <small data-testid="myself-distributionChannel-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                            }
                          </div>
                          }
                        </div>
                      }
                      @if (saleForm.get('sellerType')?.value === 'system') {
                        <div class="row">
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
                            <label data-testid="user-label" class="block text-sm" for="systemUserId">
                              {{ 'SALE_CREATE.SYSTEM_SELLER' | translate }} <i class="icon-required-field"></i>
                            </label>
                            <app-custom-dropdown data-testid="system-user"
                              [placeholder]="'SALE_CREATE.SELECT_SYSTEM_SELLER' | translate"
                              optionLabel="text"
                              optionValue="id"
                              [isMultiselect]="false"
                              [showSelectionChips]="true"
                              [showClear]="true"
                              [searchMode]="'remote'"
                              [pageSize]="combosData['systemUsers'].rowsPerPageOption || 5"
                              [totalCount]="combosData['systemUsers'].totalRecords"
                              [totalPages]="getTotalPages(combosData['systemUsers'].totalRecords, combosData['systemUsers'].rowsPerPageOption || 5)"
                              [options]="combosData['systemUsers'].list"
                              formControlName="systemUserId"
                              (onLazyLoad)="onLazyLoadComboData('systemUsers', $event)">
                            </app-custom-dropdown>
                            @if (saleForm.get('systemUserId')?.invalid && saleForm.get('systemUserId')?.touched) {
                              <small data-testid="system-user-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                            }
                          </div>
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4" [ngClass]="{ 'disabled': !saleForm.get('systemUserId')?.value?.length }">
                            <label data-testid="retailer-label" class="block text-sm" for="systemRetailerId">
                              {{ 'SALE_CREATE.POINT_OF_SALE' | translate }} <i class="icon-required-field"></i>
                            </label>
                            <app-custom-dropdown
                              data-testid="system-retailer"
                              [placeholder]="'SALE_CREATE.SELECT_RETAILER' | translate"
                              optionLabel="text"
                              optionValue="id"
                              [isMultiselect]="false"
                              [showSelectionChips]="true"
                              [showClear]="true"
                              [searchMode]="'remote'"
                              [pageSize]="combosData['systemRetailers'].rowsPerPageOption || 5"
                              [totalCount]="combosData['systemRetailers'].totalRecords"
                              [totalPages]="getTotalPages(combosData['systemRetailers'].totalRecords, combosData['systemRetailers'].rowsPerPageOption || 5)"
                              [options]="combosData['systemRetailers'].list"
                              formControlName="systemRetailerId"
                              (onLazyLoad)="onLazyLoadComboData('systemRetailers', $event)">
                            </app-custom-dropdown>
                            @if (showErrorSystemNoRetailersAssigned) {
                              <small data-testid="system-retailer-error" class="p-error">{{ 'SALE_CREATE.USER_HAS_NO_RETAILERS_ASSIGNED' | translate }}</small>
                            }
                            @if (!showErrorSystemNoRetailersAssigned && saleForm.get('systemRetailerId')?.invalid && saleForm.get('systemRetailerId')?.touched) {
                              <small data-testid="system-retailer-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' |
                              translate }}</small>
                            }
                          </div>
                          @if(showDistributionChannel){
                          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" [ngClass]="{ 'disabled': !saleForm.get('systemRetailerId')?.value?.length }">
                            <label data-testid="distributionchannel-label" class="block text-sm" for="systemDistributionChannelId">
                              {{ 'SALE_CREATE.DISTRIBUTION_CHANNEL' | translate }} <i class="icon-required-field"></i>
                            </label>
                            <app-custom-dropdown
                              data-testid="system-distributionChannel"
                              [placeholder]="'SALE_CREATE.SELECT_DISTRIBUTION_CHANNEL' | translate"
                              optionLabel="text"
                              optionValue="id"
                              [isMultiselect]="false"
                              [showSelectionChips]="true"
                              [showClear]="true"
                              [searchMode]="'remote'"
                              [pageSize]="combosData['systemDistributionChannels'].rowsPerPageOption || 5"
                              [totalCount]="combosData['systemDistributionChannels'].totalRecords"
                              [totalPages]="getTotalPages(combosData['systemDistributionChannels'].totalRecords, combosData['systemDistributionChannels'].rowsPerPageOption || 5)"
                              [options]="combosData['systemDistributionChannels'].list"
                              formControlName="systemDistributionChannelId"
                              (onLazyLoad)="onLazyLoadComboData('systemDistributionChannels', $event)">
                            </app-custom-dropdown>
                            @if (!showErrorSystemNoRetailersAssigned && saleForm.get('systemDistributionChannelId')?.invalid && saleForm.get('systemDistributionChannelId')?.touched) {
                              <small data-testid="system-distributionChannel-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                            }
                          </div>
                          }
                        </div>
                      }
                      @if (saleForm.get('sellerType')?.value === 'guest') {
                        <div class="row">
                          @if (saleForm.get('createGuestUser')?.value === false) {
                            @if (hasUnregisteredUserFeature) {
                              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4">
                                <label data-testid="user-label" class="block text-sm" for="guestUserId">
                                  {{ 'SALE_CREATE.GUEST_SELLER' | translate }} <i class="icon-required-field"></i>
                                </label>
                                <app-custom-dropdown
                                  data-testid="guest-user"
                                  [placeholder]="'SALE_CREATE.SELECT_GUEST_SELLER' | translate"
                                  optionLabel="text"
                                  optionValue="id"
                                  [isMultiselect]="false"
                                  [showSelectionChips]="true"
                                  [showClear]="true"
                                  [searchMode]="'remote'"
                                  [pageSize]="combosData['guestUsers'].rowsPerPageOption || 5"
                                  [totalCount]="combosData['guestUsers'].totalRecords"
                                  [totalPages]="getTotalPages(combosData['guestUsers'].totalRecords, combosData['guestUsers'].rowsPerPageOption || 5)"
                                  [options]="combosData['guestUsers'].list"
                                  formControlName="guestUserId"
                                  (onLazyLoad)="onLazyLoadComboData('guestUsers', $event)">
                                </app-custom-dropdown>
                                @if (saleForm.get('guestUserId')?.invalid && saleForm.get('guestUserId')?.touched) {
                                  <small data-testid="guest-user-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                                }
                              </div>
                            }
                            @if (hasUnregisteredUserFeature) {
                              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4" [ngClass]="{ 'disabled': !saleForm.get('guestUserId')?.value?.length }">
                                <label data-testid="retailer-label" class="block text-sm" for="guestRetailerId">
                                  {{ 'SALE_CREATE.POINT_OF_SALE' | translate }} <i class="icon-required-field"></i>
                                </label>
                                <app-custom-dropdown
                                  data-testid="guest-retailer"
                                  [placeholder]="'SALE_CREATE.SELECT_RETAILER' | translate"
                                  optionLabel="text"
                                  optionValue="id"
                                  [isMultiselect]="false"
                                  [showSelectionChips]="true"
                                  [showClear]="true"
                                  [searchMode]="'remote'"
                                  [pageSize]="combosData['guestRetailers'].rowsPerPageOption || 5"
                                  [totalCount]="combosData['guestRetailers'].totalRecords"
                                  [totalPages]="getTotalPages(combosData['guestRetailers'].totalRecords, combosData['guestRetailers'].rowsPerPageOption || 5)"
                                  [options]="combosData['guestRetailers'].list"
                                  formControlName="guestRetailerId"
                                  (onLazyLoad)="onLazyLoadComboData('guestRetailers', $event)">
                                </app-custom-dropdown>
                                @if (showErrorGuestNoRetailersAssigned) {
                                  <small data-testid="guest-retailer-error" class="p-error">{{ 'SALE_CREATE.USER_HAS_NO_RETAILERS_ASSIGNED' | translate }}</small>
                                }
                                @if (!showErrorGuestNoRetailersAssigned && saleForm.get('guestRetailerId')?.invalid && saleForm.get('guestRetailerId')?.touched) {
                                  <small data-testid="guest-retailer-error" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                                }
                              </div>
                            }
                            @if (hasUnregisteredUserFeature) {
                              @if(showDistributionChannel){
                              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4"
                                [ngClass]="{ 'disabled': !saleForm.get('guestRetailerId')?.value?.length }">
                                <label data-testid="distributionchannel-label" class="block text-sm" for="guestDistributionChannelId">
                                  {{ 'SALE_CREATE.DISTRIBUTION_CHANNEL' | translate }} <i class="icon-required-field"></i>
                                </label>
                                <app-custom-dropdown
                                  data-testid="guest-distributionChannel"
                                  [placeholder]="'SALE_CREATE.SELECT_DISTRIBUTION_CHANNEL' | translate"
                                  optionLabel="text"
                                  optionValue="id"
                                  [isMultiselect]="false"
                                  [showSelectionChips]="true"
                                  [showClear]="true"
                                  [searchMode]="'remote'"
                                  [pageSize]="combosData['guestDistributionChannels'].rowsPerPageOption || 5"
                                  [totalCount]="combosData['guestDistributionChannels'].totalRecords"
                                  [totalPages]="getTotalPages(combosData['guestDistributionChannels'].totalRecords, combosData['guestDistributionChannels'].rowsPerPageOption || 5)"
                                  [options]="combosData['guestDistributionChannels'].list"
                                  formControlName="guestDistributionChannelId"
                                  (onLazyLoad)="onLazyLoadComboData('guestDistributionChannels', $event)">
                                </app-custom-dropdown>
                                @if (!showErrorGuestNoRetailersAssigned && saleForm.get('guestDistributionChannelId')?.invalid && saleForm.get('guestDistributionChannelId')?.touched) {
                                  <small data-testid="guest-distributionChannel-error" class="p-error">{{'FORMS.MANDATORY_FIELD' | translate }}</small>
                                }
                              </div>
                              }
                            }
                            @if (!hasUnregisteredUserFeature && !saleForm.get('changeSeller')?.value) {
                              <div class="field-wr flex items-center gap-x-8 whitespace-nowrap col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                <label data-testid="previus_seller_assigned_label" class="text-sm">{{ 'SALE_CREATE.PREVIOUSLY_ASSIGNED_SELLER' | translate: { sellerName: unregisteredUserName} }}
                                </label>
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-sale-update-sale-button" class="btn primary-btn" [disabled]="saleForm.invalid" (click)="submitForm()">{{ 'SALE_UPDATE.BTN_UPDATE_SALE' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
